import FeeDiscount from './fee-discount.interface';

export default class DiscountItemRule implements FeeDiscount {
  id: string;

  description: string;

  discount: number;

  discountType: string;

  applyDiscount: boolean;

  constructor(obj: any = {}) {
    this.id = obj.id || '';
    this.description = obj.description || '';
    this.discount = obj.discount || 0;
    this.discountType = obj.discountType || '';
    this.applyDiscount = obj.applyDiscount || false;
  }

  public static of(obj: any = {}): DiscountItemRule {
    return new DiscountItemRule(obj || {});
  }

  public static ofList(obj: any[]): DiscountItemRule[] {
    return obj.map(this.of);
  }

  getId(): string { return this.id; }

  getDescription(): string { return this.description; }

  getValue(): number { return this.discount; }

  getType(): string { return this.discountType; }

  getApply(): boolean { return this.applyDiscount; }
}
